var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-repeat.d163a8ea.png","uri@2x": __webpack_public_path__ + "icon-repeat.42d6269b.png","uri@3x": __webpack_public_path__ + "icon-repeat.cb0262b9.png",
    width: 32,
    height: 29
});